const locale = {
  ru: {
    label: 'Русский',
    value: 'ru',
  },
  uk: {
    label: 'Українська',
    value: 'uk',
  },
};

export default locale;
